//tslint:disable:export-name
export { RatingsReviewsService } from './service-setup/RatingsReviewsService';
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo } from 'elc-universal-utils';

diContainer.get(serviceNames.ratingsReviewsService).register();

setupServiceInfo(__serviceInfo__);
